module.exports = __webpack_public_path__ + "img/conveniencias-01.d7537c09.png";